<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <!-- CONTENT -->
    <div class="content" [ngClass]="this.view" style="overflow-y: scroll;">

        <div class="cards" fxLayout="row wrap" fxLayout.xs="column wrap">
            <div class="card" *ngFor="let card of cards" fxFlex="20">
                <!-- PREVIEW -->
                <div class="card-preview" fxFlex="100">

                    <div class="fuse-card" fxFlex="100">

                        <div class="p-16 pt-0 line-height-1.75">
                            <h3><a class="nav-link" matRipple routerLink="/customers/cards/{{card.userId}}" [routerLinkActive]="[]">{{card.cardNumber}}</a></h3>
                            <h4>
                                <a (click)="showCustomerContactDetails(card.user)" style="cursor: pointer;">
                                    {{card.firstName}} {{card.lastName}} ({{card.username}})
                                </a>
                            </h4>
                            <h4>{{'Entrance date'|translate}}: {{card.createdAt|date: 'dd.MM.y HH:mm:ss': 'UTC+2': locale}}</h4>
                        </div>

                        <div class="p-8 pt-0" fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <a mat-button color="accent" routerLink="/customers/cards/{{card.cardId}}/history/{{card.userId}}">{{'HISTORY'|translate}}</a>
                                <a mat-button color="accent" (click)="openExitCardDialog(card)" [routerLinkActive]="[]">{{'EXIT'|translate}}</a>
                            </div>

                        </div>

                    </div>

                </div>
                <!-- / PREVIEW -->
            </div>


        </div>
    </div>

</div>
